exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog {\n\tpadding: 1em;\n}\n\n.modal-dialog .home-heading {\n  color: #007aff;\n  font-size: 23px;\n  font-weight: bold;\n  margin-bottom: 20px; \n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/confirm-modal/confirm-modal.component.css
// module id = ../../../../../src/app/modals/confirm-modal/confirm-modal.component.css
// module chunks = main